import React from 'react';
interface EyebrowProps {
  children: React.ReactNode;
  tone?: 'accent' | 'muted' | 'light';
}
export function Eyebrow({
  children,
  tone = 'accent'
}: EyebrowProps) {
  const toneClass = tone === 'accent' ? 'text-accent' : tone === 'light' ? 'text-cream/70' : 'text-ink-mute';
  return <p className={`text-[11px] font-semibold uppercase tracking-eyebrow ${toneClass}`} data-id="element-268" data-mp="2e8gp8icdzl77">
      {children}
    </p>;
}